import { matchLegacyAdminPathToSettingsSection } from './legacy_admin_routes'
import { matchLegacyOrganizationPathToSettingsSection } from './legacy_organization_routes'
import { matchLegacyPersonalPathToSettingsSection } from './legacy_personal_routes'

const LEGACY_SETTINGS_URL_BASE = 'https://calendly.local'

const parseLegacyPath = (legacyPath) => {
  if (typeof legacyPath !== 'string') {
    return null
  }
  try {
    return new URL(legacyPath, LEGACY_SETTINGS_URL_BASE)
  } catch (_error) {
    return null
  }
}

/**
 * Same as {@link matchLegacySettingsPathToSettingsSection} for a bare pathname.
 * @param {string} pathname — `location.pathname`
 * @returns {{ section: string, settingsTab: string | null } | null}
 */
export function matchLegacySettingsPathnameToSettingsSection(pathname) {
  if (pathname === '/app/admin' || pathname.startsWith('/app/admin/')) {
    return matchLegacyAdminPathToSettingsSection(pathname, '/app/admin')
  }
  if (pathname === '/app/organization' || pathname.startsWith('/app/organization/')) {
    return matchLegacyOrganizationPathToSettingsSection(pathname, '/app/organization')
  }
  if (pathname === '/app/personal' || pathname.startsWith('/app/personal/')) {
    return matchLegacyPersonalPathToSettingsSection(pathname)
  }
  return null
}

/**
 * Resolve a legacy settings URL/path to the modal section it represents.
 * @param {string} legacyPath — full URL or pathname (e.g. `/app/personal/profile/general`)
 * @returns {{ section: string, settingsTab: string | null } | null}
 */
export function matchLegacySettingsPathToSettingsSection(legacyPath) {
  const url = parseLegacyPath(legacyPath)
  if (url == null) {
    return null
  }
  return matchLegacySettingsPathnameToSettingsSection(url.pathname)
}
